"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "morsano-al-tagliamento": {
    "9d1d2e75": [{
      "hkey": "d8ebbfee",
      "slug": "saletto-bando",
      "name": "Saletto-Bando",
      "primary": true,
      "skipSearch": false
    }],
    "bando": [{
      "hkey": "d8ebbfee",
      "slug": "saletto-bando",
      "name": "Saletto-Bando",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "morsano-al-tagliamento"
    }],
    "c532d1e1": [{
      "hkey": "e97b6413",
      "slug": "morsano-al-tagliamento",
      "name": "Morsano al Tagliamento",
      "primary": true,
      "skipSearch": false
    }],
    "bolzano": [{
      "hkey": "e97b6413",
      "slug": "morsano-al-tagliamento",
      "name": "Morsano al Tagliamento",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0028d86b": [{
      "hkey": "d8ebbfee",
      "slug": "saletto-bando",
      "name": "Saletto-Bando",
      "primary": true,
      "skipSearch": false
    }],
    "saletto": [{
      "hkey": "d8ebbfee",
      "slug": "saletto-bando",
      "name": "Saletto-Bando",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;